import useDataFetchWithPusher from "../effects/useDataFetchWithPusher";
function useFetchUser(additionalEvents = []) {
  const { error, loading, results } = useDataFetchWithPusher(
    "/users?offset=0&&limit=1000",
    [...additionalEvents, "user-created"]
  );

  return {
    error,
    loading,
    results: results.items || [],
  };
}
export default useFetchUser;
